import RequestStatus from "../model/RequestStatus";
import { BannerContentResponse } from "../model/BannerContent";

export const BANNER_CONTENT_QUERY_START = 'BANNER_CONTENT_QUERY_START';
export const BANNER_CONTENT_QUERY_SUCCESS = 'BANNER_CONTENT_QUERY_SUCCESS';
export const BANNER_CONTENT_QUERY_FAILED = 'BANNER_CONTENT_QUERY_FAILED';

export interface BannerContentQueryStartAction {
    readonly type: string;
    readonly countryCode: string;
    readonly isWidget: boolean;
    readonly requestStatus: RequestStatus;
}

export const setBannerContentQueryStart = (countryCode:string, isWidget: boolean): BannerContentQueryStartAction => ({
    type: BANNER_CONTENT_QUERY_START,
    countryCode: countryCode,
    isWidget: isWidget,
    requestStatus: RequestStatus.LOADING,
});

export interface GetBannerContentQueryComplete {
    readonly type: string;
    readonly requestStatus: RequestStatus;
    readonly bannerContentList: any;
}

export const getBannerContentQuerySuccessAction = (response: BannerContentResponse): GetBannerContentQueryComplete => ({
    type: BANNER_CONTENT_QUERY_SUCCESS,
    requestStatus: RequestStatus.SUCCESS,
    bannerContentList: response.bannerContentList
});

export const getBannerContentQueryFailedAction = (): GetBannerContentQueryComplete => ({
    type: BANNER_CONTENT_QUERY_FAILED,
    requestStatus: RequestStatus.ERROR,
    bannerContentList: null
});
